import { Pipe, PipeTransform } from '@angular/core';

@Pipe({
  name: 'utcToLocal',
})
export class UtcToLocalPipe implements PipeTransform {
  transform(value: any): any {
    if (!value) return null;

    let date: Date;

    if (value instanceof Date) {
      date = value;
    } else {
      const s = String(value).trim();
      if (/^\d{4}-\d{2}-\d{2} \d{2}:\d{2}:\d{2}$/.test(s)) {
        // e.g. "2025-10-15 02:43:00" → treat as UTC
        date = new Date(s.replace(' ', 'T') + 'Z');
      } else {
        date = new Date(s);
      }
    }

    return isNaN(date.getTime()) ? null : date;
  }
}
